import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Context } from "./Utils/Store";
import axios from "axios";
import Button from '@mui/material/Button';
import { formatDate, formatYMD, formatNumber } from './Utils/Formatters';
import { getAppSettings } from "./Utils/AppSettings"
import './css/App.css';

function Home() {
  window.scrollTo(0, 0);

  const history = useHistory();
  const [store, setStore] = useContext(Context);
  const [loading, setLoading] = useState(true);

  const handleClick = () => {
    history.goBack();
  }

  const dow = (day) => {
    const days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    return days[day];
  }

  const dayLabel = (workDay) => {
    let dt = new Date(store.driver.PeriodStart);
    dt.setDate(dt.getDate() + workDay);
    return dow(dt.getDay()) + " " + String(dt.getMonth() + 1) + "/" + String(dt.getDate());
  }

  const hrsDate = (workDay) => {
    const dt = new Date(store.driver.PeriodStart);
    dt.setDate(dt.getDate() + workDay);
    return formatYMD(dt);
  }

  const dayHours = (workDay) => {
    const day = hrsDate(workDay);

    let hrs = 0;
    store.period.map((item) => {
      if (String(item.WorkDate).slice(0, 10) === day) {
        hrs += item.GuaranteedHours;
      }
      return null;
    });

    return hrs === 0 ? "" : formatNumber(hrs, 2);
  }

  const locked = (dow) => {
    const today = formatYMD(new Date());
    const dt = hrsDate(dow);
    return today !== dt;
  }

  const handleDay = (e) => {
    e.preventDefault();

    const dow = Number(e.target.attributes.day.value);
    const day = hrsDate(dow);

    setStore({ type: "WORKDAY", payload: day });
    setStore({ type: "DAY_LABEL", payload: dayLabel(dow) });

    history.push({
      pathname: "Trips"
    });
  }

  useEffect(() => {

    const driverObject = {
      EMKey: store.driver.EMKey,
      DriverName: store.driver.DriverName,
      PeriodStart: store.driver.PeriodStart,
      PeriodEnd: store.driver.PeriodEnd
    };

    const settings = getAppSettings();

    if (loading) {
      axios.post(settings.apiUrl + '/driver/loadperiod', driverObject).then(response => {
        setLoading(false);
        if (response.status === 200) {
          setStore({ type: "PERIOD", payload: response.data });
        } else {
          console.log("response status: " + response.status + " " + response.statusText);
        }
      }).catch(error => {
        setLoading(false);
        console.log(error);
      });
    }
  }, [loading, store, setStore]);

  return (
    <div className="page">
      <div className='vbox'>
        <div className='employee'>{store.driver.DriverName}</div>
        <div><b>Pay Period</b></div>
        <div><b>{formatDate(store.driver.PeriodStart) + " - " + formatDate(store.driver.PeriodEnd)}</b></div>
      </div>
      <table>
        <tbody>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(0)} day={0} onClick={handleDay}>{dayLabel(0)}</Button></td>
            <td><div className='hours'>{dayHours(0)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(1)} day={1} onClick={handleDay}>{dayLabel(1)}</Button></td>
            <td><div className='hours'>{dayHours(1)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(2)} day={2} onClick={handleDay}>{dayLabel(2)}</Button></td>
            <td><div className='hours'>{dayHours(2)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(3)} day={3} onClick={handleDay}>{dayLabel(3)}</Button></td>
            <td><div className='hours'>{dayHours(3)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(4)} day={4} onClick={handleDay}>{dayLabel(4)}</Button></td>
            <td><div className='hours'>{dayHours(4)}</div></td>
          </tr>
        </tbody>
      </table>
      <div className='spacer10x20' />
      <table>
        <tbody>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(7)} day={7} onClick={handleDay}>{dayLabel(7)}</Button></td>
            <td><div className='hours'>{dayHours(7)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(8)} day={8} onClick={handleDay}>{dayLabel(8)}</Button></td>
            <td><div className='hours'>{dayHours(8)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(9)} day={9} onClick={handleDay}>{dayLabel(9)}</Button></td>
            <td><div className='hours'>{dayHours(9)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(10)} day={10} onClick={handleDay}>{dayLabel(10)}</Button></td>
            <td><div className='hours'>{dayHours(10)}</div></td>
          </tr>
          <tr>
            <td><Button fullWidth={true} variant='contained' disabled={locked(11)} day={11} onClick={handleDay}>{dayLabel(11)}</Button></td>
            <td><div className='hours'>{dayHours(11)}</div></td>
          </tr>
        </tbody>
      </table>
      <div className='spacer10x20' />
      <Button variant='contained' onClick={handleClick}>LOGOUT</Button>
    </div>
  );
}

export default Home;
